goog.provide('el8.ptdata.letters');

goog.require('el8.data.educationalHandouts');
goog.require('el8.model.base');
goog.require('el8.ptdata.model.letter');
goog.require('el8.service.urls');
goog.require('el8.template.ptdata.letters');

el8.ptdata.letters = (function() {
    
    var that = new el8_EntitySet({
        model: el8.ptdata.model.letter,
        // no saveFn because we want to use an AjaxQueue
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    // Instead of defining a saveFn, we define a function that takes
    // the parameters that would usually get passed to saveItem and
    // produces the input to el8_ajax, so we can use an AjaxQueue.
    that.saveAjaxArgs = function(item, noNotify, opts) {
        opts = opts || {};
        var mapped = item.asMap(true);
        if (opts.extraArgs) {
            $.extend(mapped, opts.extraArgs);
        }
        return {
            type: 'POST',
            async: opts.async,
            data: JSON.stringify(mapped),
            url: el8.service.urls.get('saveLetter', [item]),
            success: function(data) {
                if (data.letter) {
                    // we got back a dict with letter as a key
                    item.populate(data.letter);
                    
                    // we also get back an referral order
                    // this is an update to a referral letter
                    // server is sending back the referral_order so the client can update it's referral order cache
                    if (data.referral_order) {
                        el8.ptdata.referralOrders.create(data.referral_order); 
                    }
                } else {
                    item.populate(data);
                }
                that.add(item, noNotify);
                if (opts.successCb) { opts.successCb(item); }
            },
            error: opts.errorCb
        };
    };

    that.createLetterAttachment = function(spec) {
        var patientId = spec.patientId || el8Globals.PATIENT_ID;
        var templateFile = el8.template.ptdata.letters.attachments;

        if (spec.entityId) {
            var item;
            if (el8.model.idToModelClass(spec.entityId) === 'Handout') {
                item = el8.data.educationalHandouts.getById(spec.entityId);
            } else {
                item = el8.ptdata.fetch({
                    fetchId: spec.entityId,
                    patientId: patientId
                });
            }
            var soyMap = item.asSoyMap();
            
            return el8.ptdata.model.letterAttachment({
                entityId: soyMap.id,
                attachmentType: 'Entity',
                confidential: soyMap.isConfidential,
                entityDescription: templateFile.rawTitleText(soyMap).el8_unescape(),
                summary: templateFile.rawDescriptionText(soyMap).el8_unescape(),
                entityDate: soyMap.documentDate
            });
        }
        if (spec.printoutName) {
            return el8.ptdata.model.letterAttachment({
                attachmentType: spec.printoutName,
                entityDescription: templateFile.rawTitleText({ modelClass: spec.printoutName }),
                summary: templateFile.rawDescriptionText({ modelClass: spec.printoutName })
            });
        }
        return null;
    };

    // Create a draft follow-up (post-dated) letter based on an input letter. Doesn't actually save the letter
    that.createReminderVersion = function(originalLetter) {
        var reminderLetter = el8.ptdata.letters.create({
            // modify the subject
            subject: 'Follow-up re: ' + originalLetter.getSubject(),
            // entirely new default body
            body: el8.template.ptdata.letters.reminderBody({ isSendToPatient: originalLetter.isSendToPatient() }),
            // copy all the possible recipient fields
            faxTo: originalLetter.getFaxTo(),
            sendToName: originalLetter.getSendToName(),
            sendToContactId: originalLetter.getSendToContactId(),
            sendToPatient: originalLetter.isSendToPatient(),
            // copy faxAttachments field
            faxAttachments: originalLetter.isFaxAttachments(),
            // and post-date to 2 weeks from today
            deliveryDate: el8.service.tz.todayPlusDays(14)
        });

        return reminderLetter;
    };

    return that;
    
})();
